// extracted by mini-css-extract-plugin
export default {"PageContainer":"_PageContainer--Ka49q","Webhook":"_Webhook--RwUC3"};